module.exports = __webpack_public_path__ + "static/media/roy.561dcba2.jpg";